import React, { useEffect, useState } from "react";
import { ArrowUp, MessageCircle } from "lucide-react";

const FloatingButtons = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 200);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-50">
      {/* WhatsApp */}
      <a
        href="https://wa.me/+33695753165" // ← remplace avec ton vrai numéro
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 hover:bg-green-600 text-white w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110"
        title="WhatsApp"
      >
        <MessageCircle size={22} />
      </a>

      {/* Scroll to top */}
      {showScroll && (
        <button
          onClick={scrollToTop}
          className="bg-gray-800 hover:bg-gray-900 text-white w-12 h-12 flex items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110"
          title="Retour en haut"
        >
          <ArrowUp size={20} />
        </button>
      )}
    </div>
  );
};

export default FloatingButtons;
